var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-card',[_c('v-card-text',[_c('Plan',{attrs:{"endpoint_load":'/admin/plan/plan.get?id=' + this.plan_id,"endpoint_edit":"/admin/plan/plan.edit"}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }